import { memo } from "react";
import { Handle, Position } from "reactflow";
import { FlowArrow, ArrowRight, ListNumbers } from "@phosphor-icons/react";

function ProcessNode({ data }) {
  const { name, description, steps = [], trainingMode, presentationMode, onSelect } = data;

  return (
    <div
      className={`node-card bg-white border-2 border-violet-200 rounded-md shadow-sm min-w-[240px] max-w-[300px] cursor-pointer hover:border-violet-400 ${trainingMode ? 'training-highlight relative' : ''} ${presentationMode ? 'scale-110' : ''}`}
      onClick={onSelect}
      data-testid={`process-node-${data.process_id}`}
    >
      <Handle id="t" type="source"    position={Position.Top}    className="!bg-violet-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="t-in" type="target" position={Position.Top}    className="!bg-violet-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="b" type="source"    position={Position.Bottom} className="!bg-violet-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="b-in" type="target" position={Position.Bottom} className="!bg-violet-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="l" type="source"    position={Position.Left}   className="!bg-violet-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="l-in" type="target" position={Position.Left}   className="!bg-violet-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="r" type="source"    position={Position.Right}  className="!bg-violet-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="r-in" type="target" position={Position.Right}  className="!bg-violet-500 !w-3 !h-3 !border-2 !border-white" />
      
      <div className="bg-violet-50 px-4 py-3 border-b border-violet-100">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-md bg-violet-100 flex items-center justify-center">
            <FlowArrow size={22} weight="bold" className="text-violet-600" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-base text-foreground">{name}</h3>
          </div>
        </div>
      </div>

      <div className="px-4 py-3">
        {description && <p className="text-xs text-muted-foreground line-clamp-2 mb-3">{description}</p>}
        
        {steps.length > 0 && (
          <div className="mb-2">
            <div className="flex items-center gap-1 mb-1">
              <ListNumbers size={12} className="text-violet-500" />
              <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{steps.length} Steps</p>
            </div>
            <div className="space-y-1">
              {steps.slice(0, 3).map((step, idx) => (
                <div key={idx} className="flex items-start gap-2">
                  <span className="w-4 h-4 rounded-full bg-violet-100 text-violet-600 text-[10px] font-bold flex items-center justify-center flex-shrink-0 mt-0.5">{step.step}</span>
                  <span className="text-[11px] text-foreground line-clamp-1">{step.name}</span>
                </div>
              ))}
              {steps.length > 3 && <p className="text-[10px] text-muted-foreground pl-6">+{steps.length - 3} more steps</p>}
            </div>
          </div>
        )}

        <div className="flex items-center justify-end mt-2 text-violet-600 text-xs font-medium">
          <span>View Process</span>
          <ArrowRight size={12} className="ml-1" />
        </div>
      </div>
    </div>
  );
}

export default memo(ProcessNode);
